import axios from "@/plugins/axios";
import moment from "moment/moment";
import { TicketsPaginated } from "@/types/TicketsPagined.model";
import {Site} from "@/shared/Site";

export default {
  async getDocuments(searchCritWithFormat: any, selectedSite: Site[]): Promise<any> {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    // tslint:disable-next-line: max-line-length
    // console.log(searchCritWithFormat);
    const searchCrit: any = {};
    for (const cleFiltre of Object.keys(searchCritWithFormat)) {
      if (searchCritWithFormat[cleFiltre].value !== "") {
        if (searchCritWithFormat[cleFiltre].format !== "CHOIX_MULTIPLE") {
          searchCrit[cleFiltre] = searchCritWithFormat[cleFiltre].value;
        } else {
          searchCrit["LIB_SITE"] = selectedSite.map((site) => site.libelle).join(",");
          searchCrit["RESTAURANT_ID"] = selectedSite.map((site) => site.restaurantId).join(",");
          searchCrit[cleFiltre] = searchCritWithFormat[cleFiltre].value.join(",");

        }
      }
    }

    // TODO: En attendant la correction du back ensuite on pourra enlever ce code
    // Pour forcer le filtre sur les repas employés on rajoute le critère
    if (searchCrit["DOCUMENT"] === "RECU_REGLEMENT_EMPLOYE") {
      searchCrit["TYPE"] = true;
    } else {
      // Sinon on rajoute le critère pour ne pas avoir les repas employés
      searchCrit["NO_TICKET_REPAS_EMPLOYE"] = true;
    }

    const url = "bo/getDocuments?id=" + userId;
    return axios
      .post(url, searchCrit)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
  async getDocumentsPaginated(searchCritWithFormat: any, page: number, size: number): Promise<TicketsPaginated> {
    try {
      const user = JSON.parse(localStorage.user);
      const userId = user.id;
      // tslint:disable-next-line: max-line-length
      // console.log(searchCritWithFormat);

      const searchCrit: Record<string, any> = {};

      // Construction des critères de recherche
      Object.keys(searchCritWithFormat).forEach((cleFiltre) => {
        const critere = searchCritWithFormat[cleFiltre];
        if (critere.value !== "") {
          if (critere.format !== "CHOIX_MULTIPLE") {
            searchCrit[cleFiltre] = critere.value;
          } else {
            searchCrit[cleFiltre] = Array.isArray(critere.value)
              ? critere.value.join(",")
              : critere.value;
          }
        }
      });

      // TODO: En attendant la correction du back ensuite on pourra enlever ce code
      // Pour forcer le filtre sur les repas employés on rajoute le critère
      if (searchCrit["DOCUMENT"] === "RECU_REGLEMENT_EMPLOYE") {
        searchCrit["TYPE"] = true;
      } else {
        // Sinon on rajoute le critère pour ne pas avoir les repas employés
        searchCrit["NO_TICKET_REPAS_EMPLOYE"] = true;
      }

      // Ajout des arguments de pagination
      searchCrit["PAGINATION_SIZE"] = size;
      searchCrit["PAGINATION_PAGE"] = page;

      const url = `bo/getDocuments/pagined/total?id=${userId}`;
      const response = await axios.post(url, searchCrit);

      if (!response.data || typeof response.data !== "string") {
        console.error("getDocumentsPaginated: Réponse inattendue du serveur:", response.data);
        return {
          content: [],
          page,
          size,
          numberOfElements: 0,
          hasNext: false,
        };
      }

      return JSON.parse(response.data
        .replace(/,\s*}/g, "}")  // Supprime virgule avant }
        .replace(/,\s*]/g, "]")  // Supprime virgule avant ]
        .trim());

    } catch (error: any) {
      console.error("Erreur getDocumentsPaginated:", error);
      throw new Error(`Erreur lors de la récupération des documents: ${error.message}`);
    }
  },
  async getDocument(ticket: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    // console.log(ticket);
    const date = moment(ticket.dateFiscale).format("YYYY-MM-DD");
    const url = `bo/getPdfDocument?id=${userId}&docId=${ticket.id}&restaurantId=${ticket.restaurantId}&dateFiscale=${date}&doc=${ticket.document}`;
    return axios
      .get(url, { responseType: "arraybuffer" })
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
  async getPdfTickets(searchCrit: any): Promise<any> {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    // tslint:disable-next-line: max-line-length
    const url = `bo/getPdfTickets?id=${userId}`;
    const searchCritFormatted: any = {};

    for (const cleFiltre of Object.keys(searchCrit)) {
      searchCritFormatted[cleFiltre] = JSON.stringify(
        searchCrit[cleFiltre]
      )
        .replaceAll("\"", "")
        .replace("[", "")
        .replace("]", "");
    }

    return axios
      .post(url, searchCritFormatted, { responseType: "blob" })
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
  async getFilters(): Promise<any> {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = "bo/getFilters?id=" + userId;
    return axios
      .get(url)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
  async getTicketAudit(ticket: any): Promise<any> {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = "consolidation/getTicket?uuid=" + ticket.id;
    return axios
      .get(url)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        if (myerror) {
          throw new Error(JSON.stringify(myerror));
        } else {
          throw new Error();
        }
      });
  },
};
